import React, { useState } from "react";
import styles from "./RoundedTabs.module.scss";
import { useBrandingContext } from "app-context/BrandingsContext";
import { addOpacityToColor } from "helpers/addOpacityToColor";

const RoundedTabs = ({
  tabs,
  padding,
  width,
  activeTab: externalActiveTab,
  setActiveTab: externalSetActiveTab,
  rightItems,
  tabHeaderClassName,
}) => {
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor, page_TextColor } = brandingData;

  const [internalActiveTab, setInternalActiveTab] = useState(0);

  const isControlled =
    externalActiveTab !== undefined && externalSetActiveTab !== undefined;

  const activeTab = isControlled ? externalActiveTab : internalActiveTab;
  const setActiveTab = isControlled
    ? externalSetActiveTab
    : setInternalActiveTab;

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div className={styles.container}>
      <div className={styles["right-items-mobile"]}>{rightItems}</div>

      <div className={styles["tab-header-container"]}>
        <div
          className={`${styles.tabHeader} ${
            padding ? styles.padding : ""
          } ${tabHeaderClassName}`}
        >
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`${styles.tabButton} ${
                index === activeTab ? styles.active : ""
              }`}
              onClick={() => handleTabClick(index)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className={styles["right-items"]}>{rightItems}</div>
      </div>

      {tabs[activeTab]?.content && (
        <div className={styles.tabContent}>{tabs[activeTab].content}</div>
      )}
    </div>
  );
};

export default RoundedTabs;
